<ng-container *ngIf="showSearch$ | async">
  <div class="d-flex justify-content-end top-search">
    <mat-form-field class="mt-1 mx-2 search-input">
      <input
        id="mat-search-trip"
        type="text"
        placeholder="Search"
        aria-label="Search"
        [(ngModel)]="searchText"
        name="searchText"
        matInput
        autocomplete="off"
        (keyup)="searchTrip()"
        (click)="sendClickEvent()"
      />

      <mat-icon matSuffix (click)="searchTrip()">search</mat-icon>
    </mat-form-field>

    <div class="search-autocomplete" [class.d-none]="!autoCompleteOpened">
      <div class="search-datepicker">
        <div class="d-flex justify-content-center w-100 py-2" tabindex="1">
          <mat-form-field class="px-2 search-date-input">
            <input
              matInput
              [matDatepicker]="pickerStartDate"
              placeholder="Start Date"
              [(ngModel)]="startDateTime"
              name="startDateTime"
              (dateChange)="searchTrip()"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerStartDate (opened)="openDatePicker()"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="px-2 search-date-input">
            <input
              matInput
              [matDatepicker]="pickerEndDate"
              placeholder="End Date"
              [(ngModel)]="endDateTime"
              name="endDateTime"
              (dateChange)="searchTrip()"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerEndDate (opened)="openDatePicker()"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="search-trips">
        <div
          *ngFor="let trip of trips; let i = index"
        >
        <div
          class="search-row"
          [ngClass]="{ 'row-hover': isPreFlight }"
          (click)="onTripRowClick(trip)"
        >
            <div class="d-flex justify-content-start">
              <span class="plain-icon">
                <mat-icon>flight</mat-icon>
              </span>
              <span>
                <p class="fs-12 mb-1">Trip ID</p>
                <p class="mb-0">{{ trip.customTripId }}</p>
              </span>
            </div>
            <div 
              class="search-row-down pt-1" 
              [ngClass]="{ 'row-hover': !isPreFlight }"
              *ngFor="let icao of trip.icaos || []; let i = index"
              (click)="onTripIcaoClick(icao)"
            >
              <div class="left-section">
                <h4 class="mb-0">{{ icao.departureIcao }}</h4>
                <h4 class="mb-0">{{ icao.startDate | date : 'MM/dd/yyyy' }}</h4>
              </div>
              <div class="right-section">
                <h4 class="mb-0">{{ icao.arrivalIcao }}</h4>
                <h4 class="mb-0">{{ icao.endDate | date : 'MM/dd/yyyy' }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
